import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getErrorMessage } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(getErrorMessage(e));
      return false;
    }
  };

  const register = async (first_name, last_name, email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", { first_name, last_name, email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(getErrorMessage(e));
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed:", err);
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, error, setError, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
